// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"7e58771b","273":"aa087717","525":"8edf891d","606":"71640d02","832":"2dde13f5"}[chunkId] + ".chunk.js";
};